import { ExportTypeBaseService } from '@/modules/export/services/ExportTypeBaseService';
import { FileExtension } from '@/modules/core/app/constants/app.constants';
import Lang from '@/modules/core/app/services/Lang';

export class DiagnosticToolResultsPageExportService extends ExportTypeBaseService {
  getFilename(): string {
    return Lang.t('tools.export-results-filename-pdf') + FileExtension.PDF;
  }

  getSnackBarTitle(): string {
    return Lang.t('tools.exporting-results-pdf');
  }
}

export default new DiagnosticToolResultsPageExportService();
